const initialEditorstate = {
  firstName: '',
  lastname: '',
  email: '',
  password: '',
  organizationId: '',
  passwordConfirm: '',
  phone: '',
  mobilePhone: '',
};

export default initialEditorstate;
